import React from 'react';
import { QuestionnaireResult } from '../../../../../graphql/graphql';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import QuestionnaireResultWithScoringDetail from './QuestionnaireResultWithScoringDetail';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	item: QuestionnaireResult;
	onSubmit: () => void;
}

const QuestionnaireResultWithScoringDetailModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='base.questionnaireResult.one'
			size={Size.FULLSCREEN}>
			<QuestionnaireResultWithScoringDetail
				item={props.item}
				onSubmit={props.onSubmit}
			/>
		</BaseModal>
	);
};

export default QuestionnaireResultWithScoringDetailModal;
